import { connect } from 'react-redux';
import MeuPerfil from './meuPerfil';

export default connect()(MeuPerfil);
